"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var GlobalizationContext_1 = require("../globalization/GlobalizationContext");
/**
 * @hidden
 */
exports.useInternationalization = function () { return React.useContext(GlobalizationContext_1.GlobalizationContext).intl; };
//# sourceMappingURL=useInternationalization.js.map